import React, { Component } from 'react';
import { Link } from 'react-router-dom';
export function DesignSystemPage() {
  return <div className="w-full min-h-screen bg-white pt-24 pb-20" data-id="element-705">
      <div className="container mx-auto px-6" data-id="element-706">
        <div className="max-w-5xl mx-auto" data-id="element-707">
          {/* Header */}
          <div className="mb-16" data-id="element-708">
            <h1 className="text-4xl md:text-5xl font-normal text-black mb-4" data-id="element-709">
              Design System
            </h1>
            <p className="text-xl text-gray-700" data-id="element-710">
              Guía de estilos y componentes para explorandoconfran
            </p>
            <div className="mt-8 flex" data-id="element-711">
              <Link to="/" className="text-black hover:text-gray-700 transition-colors flex items-center" data-id="element-712">
                ← Volver al inicio
              </Link>
            </div>
          </div>
          {/* Color Palette */}
          <section className="mb-20" data-id="element-713">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-714">
              Paleta de Colores
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-715">
              <div data-id="element-716">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-717">
                  Primarios
                </h3>
                <div className="space-y-6" data-id="element-718">
                  <div data-id="element-719">
                    <div className="h-20 bg-black rounded-lg mb-2" data-id="element-720"></div>
                    <div className="flex justify-between" data-id="element-721">
                      <span className="text-sm font-medium" data-id="element-722">Negro</span>
                      <span className="text-sm text-gray-600" data-id="element-723">#000000</span>
                    </div>
                  </div>
                  <div data-id="element-724">
                    <div className="h-20 bg-white rounded-lg border border-gray-200 mb-2" data-id="element-725"></div>
                    <div className="flex justify-between" data-id="element-726">
                      <span className="text-sm font-medium" data-id="element-727">Blanco</span>
                      <span className="text-sm text-gray-600" data-id="element-728">#FFFFFF</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-729">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-730">Grises</h3>
                <div className="space-y-6" data-id="element-731">
                  <div data-id="element-732">
                    <div className="h-10 bg-gray-50 rounded-lg mb-2" data-id="element-733"></div>
                    <div className="flex justify-between" data-id="element-734">
                      <span className="text-sm font-medium" data-id="element-735">Gris 50</span>
                      <span className="text-sm text-gray-600" data-id="element-736">bg-gray-50</span>
                    </div>
                  </div>
                  <div data-id="element-737">
                    <div className="h-10 bg-gray-100 rounded-lg mb-2" data-id="element-738"></div>
                    <div className="flex justify-between" data-id="element-739">
                      <span className="text-sm font-medium" data-id="element-740">Gris 100</span>
                      <span className="text-sm text-gray-600" data-id="element-741">bg-gray-100</span>
                    </div>
                  </div>
                  <div data-id="element-742">
                    <div className="h-10 bg-gray-200 rounded-lg mb-2" data-id="element-743"></div>
                    <div className="flex justify-between" data-id="element-744">
                      <span className="text-sm font-medium" data-id="element-745">Gris 200</span>
                      <span className="text-sm text-gray-600" data-id="element-746">bg-gray-200</span>
                    </div>
                  </div>
                  <div data-id="element-747">
                    <div className="h-10 bg-gray-600 rounded-lg mb-2" data-id="element-748"></div>
                    <div className="flex justify-between" data-id="element-749">
                      <span className="text-sm font-medium text-white" data-id="element-750">
                        Gris 600
                      </span>
                      <span className="text-sm text-gray-300" data-id="element-751">bg-gray-600</span>
                    </div>
                  </div>
                  <div data-id="element-752">
                    <div className="h-10 bg-gray-700 rounded-lg mb-2" data-id="element-753"></div>
                    <div className="flex justify-between" data-id="element-754">
                      <span className="text-sm font-medium text-white" data-id="element-755">
                        Gris 700
                      </span>
                      <span className="text-sm text-gray-300" data-id="element-756">bg-gray-700</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Typography */}
          <section className="mb-20" data-id="element-757">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-758">Tipografía</h2>
            <div className="space-y-12" data-id="element-759">
              <div data-id="element-760">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-761">
                  Encabezados
                </h3>
                <div className="space-y-8 bg-gray-50 p-8 rounded-lg" data-id="element-762">
                  <div data-id="element-763">
                    <h1 className="text-5xl font-normal text-black mb-2" data-id="element-764">
                      Título H1
                    </h1>
                    <p className="text-sm text-gray-600" data-id="element-765">
                      text-5xl font-normal
                    </p>
                  </div>
                  <div data-id="element-766">
                    <h2 className="text-4xl font-normal text-black mb-2" data-id="element-767">
                      Título H2
                    </h2>
                    <p className="text-sm text-gray-600" data-id="element-768">
                      text-4xl font-normal
                    </p>
                  </div>
                  <div data-id="element-769">
                    <h3 className="text-3xl font-normal text-black mb-2" data-id="element-770">
                      Título H3
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-771">
                      text-3xl font-normal
                    </p>
                  </div>
                  <div data-id="element-772">
                    <h4 className="text-2xl font-normal text-black mb-2" data-id="element-773">
                      Título H4
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-774">
                      text-2xl font-normal
                    </p>
                  </div>
                  <div data-id="element-775">
                    <h5 className="text-xl font-normal text-black mb-2" data-id="element-776">
                      Título H5
                    </h5>
                    <p className="text-sm text-gray-600" data-id="element-777">text-xl font-normal</p>
                  </div>
                </div>
              </div>
              <div data-id="element-778">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-779">
                  Párrafos
                </h3>
                <div className="space-y-8 bg-gray-50 p-8 rounded-lg" data-id="element-780">
                  <div data-id="element-781">
                    <p className="text-lg text-gray-700 mb-2 leading-relaxed" data-id="element-782">
                      Párrafo grande: Más de 17 mil almas curiosas me acompañan
                      en cada camino. Juntos recorremos montañas, ríos y
                      senderos que cuentan historias.
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-783">
                      text-lg text-gray-700 leading-relaxed
                    </p>
                  </div>
                  <div data-id="element-784">
                    <p className="text-base text-gray-700 mb-2 leading-relaxed" data-id="element-785">
                      Párrafo normal: Más de 17 mil almas curiosas me acompañan
                      en cada camino. Juntos recorremos montañas, ríos y
                      senderos que cuentan historias.
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-786">
                      text-base text-gray-700 leading-relaxed
                    </p>
                  </div>
                  <div data-id="element-787">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-788">
                      Texto pequeño: Más de 17 mil almas curiosas me acompañan
                      en cada camino.
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-789">
                      text-sm text-gray-600
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-790">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-791">Énfasis</h3>
                <div className="space-y-4 bg-gray-50 p-8 rounded-lg" data-id="element-792">
                  <p className="text-base text-gray-700" data-id="element-793">
                    Texto normal con{' '}
                    <span className="font-medium" data-id="element-794">énfasis medio</span> y{' '}
                    <span className="font-bold" data-id="element-795">énfasis fuerte</span>.
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-796">
                    font-medium, font-bold
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* Spacing */}
          <section className="mb-20" data-id="element-797">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-798">Espaciado</h2>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-799">
              <div className="space-y-6" data-id="element-800">
                <div data-id="element-801">
                  <h3 className="text-xl font-normal text-black mb-4" data-id="element-802">
                    Márgenes de sección
                  </h3>
                  <div className="bg-gray-100 p-2 rounded" data-id="element-803">
                    <div className="flex items-center space-x-4" data-id="element-804">
                      <div className="h-20 w-4 bg-black" data-id="element-805"></div>
                      <div data-id="element-806">
                        <p className="font-medium" data-id="element-807">Vertical: 5rem (80px)</p>
                        <p className="text-sm text-gray-600" data-id="element-808">py-20</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-809">
                  <h3 className="text-xl font-normal text-black mb-4" data-id="element-810">
                    Padding contenedor
                  </h3>
                  <div className="bg-gray-100 p-2 rounded" data-id="element-811">
                    <div className="flex items-center space-x-4" data-id="element-812">
                      <div className="h-4 w-20 bg-black" data-id="element-813"></div>
                      <div data-id="element-814">
                        <p className="font-medium" data-id="element-815">Horizontal: 1.5rem (24px)</p>
                        <p className="text-sm text-gray-600" data-id="element-816">px-6</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-817">
                  <h3 className="text-xl font-normal text-black mb-4" data-id="element-818">
                    Espacio entre elementos
                  </h3>
                  <div className="bg-gray-100 p-2 rounded" data-id="element-819">
                    <div className="flex flex-col space-y-4" data-id="element-820">
                      <div className="flex items-center space-x-4" data-id="element-821">
                        <div className="h-4 w-4 bg-black" data-id="element-822"></div>
                        <div data-id="element-823">
                          <p className="font-medium" data-id="element-824">Pequeño: 1rem (16px)</p>
                          <p className="text-sm text-gray-600" data-id="element-825">mb-4, gap-4</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-4" data-id="element-826">
                        <div className="h-6 w-6 bg-black" data-id="element-827"></div>
                        <div data-id="element-828">
                          <p className="font-medium" data-id="element-829">Medio: 1.5rem (24px)</p>
                          <p className="text-sm text-gray-600" data-id="element-830">mb-6, gap-6</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-4" data-id="element-831">
                        <div className="h-8 w-8 bg-black" data-id="element-832"></div>
                        <div data-id="element-833">
                          <p className="font-medium" data-id="element-834">Grande: 2rem (32px)</p>
                          <p className="text-sm text-gray-600" data-id="element-835">mb-8, gap-8</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-4" data-id="element-836">
                        <div className="h-10 w-10 bg-black" data-id="element-837"></div>
                        <div data-id="element-838">
                          <p className="font-medium" data-id="element-839">
                            Extra grande: 2.5rem (40px)
                          </p>
                          <p className="text-sm text-gray-600" data-id="element-840">mb-10, gap-10</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Components */}
          <section className="mb-20" data-id="element-841">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-842">
              Componentes
            </h2>
            {/* Buttons */}
            <div className="mb-16" data-id="element-843">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-844">Botones</h3>
              <div className="bg-gray-50 p-8 rounded-lg space-y-8" data-id="element-845">
                <div data-id="element-846">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-847">
                    Botón Primario
                  </h4>
                  <div className="flex flex-wrap gap-4 mb-4" data-id="element-848">
                    <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors" data-id="element-849">
                      Botón Primario
                    </button>
                    <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors rounded-full" data-id="element-850">
                      Botón Redondeado
                    </button>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-851">
                    bg-black text-white px-8 py-3 text-sm uppercase
                    hover:bg-gray-800 transition-colors
                  </p>
                </div>
                <div data-id="element-852">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-853">
                    Botón Secundario
                  </h4>
                  <div className="flex flex-wrap gap-4 mb-4" data-id="element-854">
                    <button className="border border-black px-8 py-3 text-sm uppercase hover:bg-gray-100 transition-colors" data-id="element-855">
                      Botón Secundario
                    </button>
                    <button className="border border-black px-8 py-3 text-sm uppercase hover:bg-gray-100 transition-colors rounded-full" data-id="element-856">
                      Botón Redondeado
                    </button>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-857">
                    border border-black px-8 py-3 text-sm uppercase
                    hover:bg-gray-100 transition-colors
                  </p>
                </div>
                <div data-id="element-858">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-859">
                    Botón Terciario
                  </h4>
                  <div className="flex flex-wrap gap-4 mb-4" data-id="element-860">
                    <button className="text-black hover:text-gray-700 transition-colors" data-id="element-861">
                      ← Volver
                    </button>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-862">
                    text-black hover:text-gray-700 transition-colors
                  </p>
                </div>
              </div>
            </div>
            {/* Cards */}
            <div className="mb-16" data-id="element-863">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-864">Tarjetas</h3>
              <div className="bg-gray-50 p-8 rounded-lg space-y-8" data-id="element-865">
                <div data-id="element-866">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-867">
                    Tarjeta Básica
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4" data-id="element-868">
                    <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-869">
                      <h3 className="text-xl font-normal text-black mb-4" data-id="element-870">
                        Título de Tarjeta
                      </h3>
                      <p className="text-base text-gray-600 leading-relaxed" data-id="element-871">
                        Contenido de la tarjeta con información relevante sobre
                        el tema en cuestión.
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-872">
                    bg-white p-8 rounded-lg shadow-sm
                  </p>
                </div>
                <div data-id="element-873">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-874">
                    Tarjeta con Borde
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4" data-id="element-875">
                    <div className="border-t-2 border-black pt-8 bg-white p-8 rounded-lg shadow-sm" data-id="element-876">
                      <h3 className="text-xl font-medium text-black mb-3" data-id="element-877">
                        Título de Tarjeta
                      </h3>
                      <p className="text-base text-gray-600 mb-4 leading-relaxed" data-id="element-878">
                        Contenido de la tarjeta con información relevante sobre
                        el tema en cuestión.
                      </p>
                      <a href="#" className="text-black hover:text-gray-700 transition-colors" data-id="element-879">
                        Saber más →
                      </a>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-880">
                    border-t-2 border-black pt-8 bg-white p-8 rounded-lg
                    shadow-sm
                  </p>
                </div>
              </div>
            </div>
            {/* Forms */}
            <div data-id="element-881">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-882">
                Formularios
              </h3>
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-883">
                <div className="max-w-md" data-id="element-884">
                  <div className="mb-6" data-id="element-885">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-886">
                      Nombre
                    </label>
                    <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black" placeholder="Tu nombre" data-id="element-887" />
                  </div>
                  <div className="mb-6" data-id="element-888">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-889">
                      Email
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black" placeholder="tu@email.com" data-id="element-890" />
                  </div>
                  <div className="mb-6" data-id="element-891">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-892">
                      Mensaje
                    </label>
                    <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black" placeholder="Escribe tu mensaje aquí" data-id="element-893"></textarea>
                  </div>
                  <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors w-full" data-id="element-894">
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </section>
          {/* Layout */}
          <section className="mb-20" data-id="element-895">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-896">Layout</h2>
            <div className="bg-gray-50 p-8 rounded-lg space-y-8" data-id="element-897">
              <div data-id="element-898">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-899">
                  Contenedor
                </h3>
                <div className="bg-gray-100 p-4 rounded" data-id="element-900">
                  <div className="w-full h-20 border-2 border-dashed border-black flex items-center justify-center" data-id="element-901">
                    <p className="text-sm text-gray-700" data-id="element-902">
                      container mx-auto px-6
                    </p>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-2" data-id="element-903">
                  Ancho máximo con márgenes automáticos y padding horizontal
                </p>
              </div>
              <div data-id="element-904">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-905">
                  Grid de 2 Columnas
                </h3>
                <div className="bg-gray-100 p-4 rounded" data-id="element-906">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-907">
                    <div className="h-20 bg-white border border-gray-200 flex items-center justify-center" data-id="element-908">
                      <p className="text-sm text-gray-700" data-id="element-909">Columna 1</p>
                    </div>
                    <div className="h-20 bg-white border border-gray-200 flex items-center justify-center" data-id="element-910">
                      <p className="text-sm text-gray-700" data-id="element-911">Columna 2</p>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-2" data-id="element-912">
                  grid grid-cols-1 md:grid-cols-2 gap-4
                </p>
              </div>
              <div data-id="element-913">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-914">
                  Grid de 3 Columnas
                </h3>
                <div className="bg-gray-100 p-4 rounded" data-id="element-915">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-916">
                    <div className="h-20 bg-white border border-gray-200 flex items-center justify-center" data-id="element-917">
                      <p className="text-sm text-gray-700" data-id="element-918">Columna 1</p>
                    </div>
                    <div className="h-20 bg-white border border-gray-200 flex items-center justify-center" data-id="element-919">
                      <p className="text-sm text-gray-700" data-id="element-920">Columna 2</p>
                    </div>
                    <div className="h-20 bg-white border border-gray-200 flex items-center justify-center" data-id="element-921">
                      <p className="text-sm text-gray-700" data-id="element-922">Columna 3</p>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mt-2" data-id="element-923">
                  grid grid-cols-1 md:grid-cols-3 gap-4
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>;
}